// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn___1S4Lb","open":"open___HZHBW","download":"download___2asm5"};